import { useUser } from "@modules/auth/hooks/useUser"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { useEffect, useState } from "react"

export const useProgramBundleRights = (programBundle?: ProgramBundleEntity) => {
  const user = useUser()
  const [isAuthor, setIsAuthor] = useState(false)

  useEffect(() => {
    if (user && programBundle && user.id === programBundle.owner.id) {
      setIsAuthor(true)
    } else {
      setIsAuthor(false)
    }
  }, [JSON.stringify(programBundle), JSON.stringify(user)])

  return { isAuthor }
}
